import React from 'react'
import "./eyes.css"
import CustomTitle from '../CustomTitle/CustomTitle.jsx'








export default function Eyes() {

   return (
      <>
         <div className="container">
            <CustomTitle title="صفحة العيون" />
            
            <h2 className='main-header mt-5 pt-5'>Eyes Profile</h2>
            <div className='under-header'></div>

            <div className="row">
               <p>Not Found Data Today`s !</p>
            </div>
         </div>
      </>
   )
}
